import React from "react";


const dataProtectionDoc = "https://docs.google.com/gview?url=https://res.cloudinary.com/dwzihftxc/image/upload/v1689376660/data_protection/qc6g8j2adncdnvjirnsb.pdf&embedded=true"


const UserAgreements = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const doc = queryParams.get("doc")
    let docUrl = dataProtectionDoc;
    if (doc === "Nutzungbedingungen") {
        docUrl = "https://docs.google.com/gview?url=https://res.cloudinary.com/dwzihftxc/image/upload/v1622844945/data_protection/AGBs_bejeti.pdf&embedded=true"
    }
    return (
        <div>
            <iframe src={docUrl} frameBorder="0" height="100%" width="100%"/>
        </div>
    )
}


export default UserAgreements;